import { Component, OnInit } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AppStateStore } from 'projects/desktop/src/app/data/app-state.store';
import { User } from 'projects/core/src/lib/login/data/user';
import { AppStateQuery } from 'projects/desktop/src/app/data/app-state.query';
import { UserService } from 'projects/core/src/lib/login/data/user.service';
import { MatDialog } from '@angular/material/dialog';
import { PdfPreviewDialogComponent } from 'projects/app-misc/src/app/modules/project-misc/view/pdf-preview-dialog/pdf-preview-dialog.component';
import { EstimateDialogComponent } from 'projects/app-misc/src/app/modules/qb/view/estimate-dialog/estimate-dialog.component';

@Component({
    selector: 'app-dash-board-main-block',
    templateUrl: './dash-board-main-block.component.html',
    styleUrls: ['./dash-board-main-block.component.scss'],
    providers: [DeviceDetectorService]
})
export class DashBoardMainBlockComponent implements OnInit {

    isMobile = false;
    currentUser: User;

    showClientNfs: boolean;

    constructor(
        protected deviceDetectorService: DeviceDetectorService,
        protected appStateQuery: AppStateQuery,
        private dialog: MatDialog,
        protected userSerivce: UserService

    ) { }

    ngOnInit(): void {

        this.isMobile = this.deviceDetectorService.isMobile();

        this.appStateQuery.currentUser$.subscribe(user => {
            this.currentUser = user;


            if (this.currentUser.adminNSuperNSales) {
                this.showClientNfs = true;
            }
      else{
        this.showClientNfs = false;
      }

            if (!this.showClientNfs) {
                this.userSerivce.getProjectManagers().subscribe(users => {
                    if (users.find(usr => usr.id === this.currentUser.id)) {
                        this.showClientNfs = true;
                    }
                    else {
                        this.showClientNfs = false;
                    }
                })
            }
        })

        // this.openEstimates();
    }

    openPdfLabels(): void {
        // this.sendData.emit(this.currentUser)
        const cpDialogRef = this.dialog.open(PdfPreviewDialogComponent, {
            data: {
                dialogHeader: 'Test',
                link: '/project/5982/files/32933',
                showSendButton: true
            },
            panelClass: 'pdf-preview-dialog'
        });
    }

    openEstimates() {
        const dialogRef = this.dialog.open(EstimateDialogComponent, {
            data: 5982,
            panelClass: 'estimates-modal-dialog',
            disableClose: false
        });

        dialogRef.afterClosed().subscribe(result => {

            // if (result === 'Success!') {
            // 	this.openSuccessSnackBar('Success!')
            // }
        });
    }

}
